import React from 'react';
import { PacmanGameState } from '../PacmanGame';

interface GameStateOverlayProps {
    gameState: PacmanGameState;
    gameStarted: boolean;
    score: number;
    level: number;
    onStartGame: () => void;
    onResetGame: () => void;
    onStartNextLevel: () => void;
}

const GameStateOverlay: React.FC<GameStateOverlayProps> = ({
    gameState,
    gameStarted,
    score,
    level,
    onStartGame,
    onResetGame,
    onStartNextLevel
}) => {
    if (gameStarted && gameState === PacmanGameState.Playing) {
        return null; // No overlay when playing
    }

    const getOverlayContent = () => {
        if (!gameStarted) {
            return {
                title: 'Press Start to Play!',
                color: '#FFFF00',
                buttonText: 'START GAME',
                buttonColor: '#FFFF00',
                onButtonClick: onStartGame
            };
        }

        switch (gameState) {
            case PacmanGameState.LevelCompleteScreen:
                return {
                    title: 'LEVEL COMPLETE!',
                    subtitle: `Score: ${score.toLocaleString()} | Level: ${level}`,
                    color: '#00FF00',
                    buttonText: `START LEVEL ${level}`,
                    buttonColor: '#FFFF00',
                    onButtonClick: onStartNextLevel
                };
            case PacmanGameState.GameOver:
                return {
                    title: 'GAME OVER',
                    subtitle: `Final Score: ${score.toLocaleString()}`,
                    color: '#FF0000',
                    buttonText: 'PLAY AGAIN',
                    buttonColor: '#00FF00',
                    onButtonClick: onResetGame
                };
            case PacmanGameState.Paused:
                return {
                    title: 'PAUSED',
                    color: '#FFFF00',
                    buttonText: 'RESUME',
                    buttonColor: '#FFFF00',
                    onButtonClick: onStartGame
                };
            default:
                return null;
        }
    };

    const content = getOverlayContent();
    if (!content) return null;

    return (
        <div className="game-overlay-card" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: content.color,
            backgroundColor: 'rgba(0,0,0,0.8)',
            padding: 'clamp(10px, 3.2vw, 20px)',
            borderRadius: '12px',
            border: `2px solid ${content.color}`,
            width: 'min(88vw, 420px)'
        }}>
            <div className="game-overlay-title" style={{ marginBottom: 'clamp(8px, 2.8vw, 16px)', fontSize: 'clamp(16px, 4.6vw, 24px)', fontWeight: 800 }}>{content.title}</div>
            {content.subtitle && (
                <div className="game-overlay-subtitle" style={{ marginBottom: 'clamp(8px, 2.8vw, 16px)', fontSize: 'clamp(12px, 3.2vw, 16px)' }}>
                    {content.subtitle}
                </div>
            )}
            <button
                onClick={content.onButtonClick}
                className="game-overlay-button"
                style={{
                    padding: 'clamp(8px, 2.6vw, 12px) clamp(12px, 3.6vw, 18px)',
                    fontSize: 'clamp(13px, 3.4vw, 16px)',
                    backgroundColor: content.buttonColor,
                    color: '#000',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 800
                }}
            >
                {content.buttonText}
            </button>
        </div>
    );
};

export default GameStateOverlay; 